import { memo } from 'react';
import clsx from 'clsx';

type PoweredByLayout1Props = {
	fixed?: boolean;
};

/**
 * The "Powered by rEngin SRS" bubble shown at the bottom right of every page, after the page content.
 * When `fixed` is set it floats over the page in the bottom right corner instead.
 */
function PoweredByLayout1(props: PoweredByLayout1Props) {
	const { fixed = false } = props;

	return (
		<div className={clsx('flex justify-end p-16', fixed ? 'fixed bottom-0 right-0 z-50' : 'mt-auto')}>
			<p className="m-0 rounded-full bg-white dark:bg-grey-800 px-14 py-6 text-sm text-gray-500 dark:text-grey-300 shadow-lg">
				Powered by{' '}
				<a className="font-semibold !text-primary !bg-transparent hover:!bg-transparent !border-b-0" href="https://renginsrs.com" target="_blank" rel="noopener noreferrer">
					rEngin SRS
				</a>
			</p>
		</div>
	);
}

export default memo(PoweredByLayout1);
